<template lang="pug">
  .card
    .card-body
      .columns(v-if="!editing")
        .column {{ grauInfracao.descricao }}
        .column.col-auto {{ grauInfracao.valor | currency('R$ ') }}
        .column.col-auto
          a.btn.btn-action.btn-sm.btn-primary.mr-1.tooltip(data-tooltip="Editar" @click="editing = true")
            i.fa.fa-edit
          a.btn.btn-action.btn-sm.btn-error.tooltip(data-tooltip="Remover" @click="onRemove")
            i.fa.fa-trash
      form-grau-infracao(v-else :grau-infracao="grauInfracao" @submit="onSubmit" @cancel="editing = false")
</template>

<script>
import FormGrauInfracao from './Form'

export default {
  props: {
    grauInfracao: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  components: { FormGrauInfracao },
  data() {
    return { editing: false }
  },
  methods: {
    onSubmit({ resource }) {
      this.$emit('submit', { resource, index: this.index })
      this.editing = false
    },
    onRemove() {
      this.$emit('remove', this.index)
    },
  },
}
</script>
